<template>
  <div
    v-if="showAddToHomeButton"
    class="add-home-screen"
  >
    <img
      src="@/assets/img/logo.png"
      class="add-home-screen__logo"
      alt="Tippie App"
    >
    <div class="add-home-screen-info">
      <div class="app-description">
        <h4>Tippie</h4>
        <p>GSI Verwaltung GmbH</p>
        <b>{{ $t("pwa-link.get-app") }}</b>
      </div>
      <a
        :href="appLink"
        class="add-home-screen__button"
      >{{
        $t("pwa-link.view")
      }}</a>
    </div>
    <div class="add-home-screen__close">
      <i
        class="el-icon-close"
        @click="hideHomeScreenButton"
      />
    </div>
  </div>
</template>

<script>
import detectOSByBrowser from "@/shared/detect-os.js";
import isWebview from "is-ua-webview";

export default {
  name: "PromotingAppsBanner",
  data: () => ({
    showAddToHomeButton: false,
    appLink: process.env.VUE_APP_ANDROID_APP,
  }),
  mounted() {
    this.appLink = ["Macintosh", "iOS"].includes(detectOSByBrowser())
      ? process.env.VUE_APP_APPLE_APP
      : process.env.VUE_APP_ANDROID_APP;
    this.addToHomeScreen();
  },
  methods: {
    addToHomeScreen() {
      if (
        !isWebview(window.navigator.userAgent) &&
        this.$cookie.get("hideAppBottomPanel") == null
      ) {
        this.showAddToHomeButton = true;
      }
    },
    addToHomeScreenClicked() {
      this.hideHomeScreenButton();
    },
    hideHomeScreenButton() {
      this.$cookie.set("hideAppBottomPanel", true, 60 * 60 * 24);
      this.showAddToHomeButton = false;
    },
  },
};
</script>

<style scoped lang="scss">
.add-home-screen {
  display: none;
  justify-content: start;
  align-items: center;
  width: 100%;
  height: 80px;
  position: fixed;
  bottom: 0;
  left: 50%;
  transform: translate(-50%);
  background: #ffffff;
  padding: 0 10px;
  box-shadow: 0 0 10px rgba(57, 20, 0, 0.04);
  border-top: 1px solid rgba(57, 20, 0, 0.04);
  z-index: 99;

  @media (max-width: 992px) {
    display: flex;
    gap: 10px;
    justify-content: flex-start;
    align-items: center;
    padding: 5px 10px;
  }

  .app-description {
    h4 {
      font-weight: bold;
      line-height: 1.5;
      margin: 0;
    }

    p {
      font-size: 12px;
      color: #797878;
      margin: 0;
    }

    b {
      font-size: 12px;
      margin: 0;
    }
  }

  &-info {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 20px;
    line-height: 1.25;
  }

  .app-description {
    h4 {
      font-weight: bold;
      line-height: 1.5;
      color: #000;
    }

    p {
      font-size: 12px;
      color: #797878;
    }

    b {
      font-size: 12px;
    }
  }

  &-info {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 20px;
    line-height: 1.25;
  }

  &__logo {
    display: inline-block;
    height: 40px;
    margin-left: 10px;
  }

  &__button {
    font-family: "Raleway Medium", serif;
    font-size: 16px;
    text-decoration: none;
    color: #ff8a00;
    margin-left: 15px;
    position: absolute;
    right: 70px;
    font-weight: bold;
  }

  &__close {
    cursor: pointer;
    position: absolute;
    right: 18px;
    font-size: 24px;
    color: #797878;
  }
}
</style>
